import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

// Este arquivo diz ao React: "Pegue tudo o que está no App.js 
// e coloque dentro da div 'root' que está no nosso index.html"
//
// O ErrorBoundary "envolve" o App inteiro — se algo quebrar em
// qualquer tela (ex: um dossiê antigo com dado incompleto), ele
// mostra uma tela explicando o problema em vez do app inteiro
// sumir e ficar em branco.

// Força a barra de status escura, sempre — não depende do tema
// nativo do Android, então funciona mesmo se o styles.xml não
// "grudar" a configuração.
if (Capacitor.isNativePlatform()) {
  StatusBar.setStyle({ style: Style.Dark });
  StatusBar.setBackgroundColor({ color: '#010208' });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);